module.exports = __webpack_public_path__ + "img/simple.7e848714.svg";